import { ErrorMessage } from '@occc-app/lib/ErrorMessage';

/* Action Types */

const REQUEST_META_DATA_OK = 'hq/Offer/Summary/REQUEST_META_DATA_OK';
const RESET_INITIAL_META_DATA_STATE = 'hq/Offer/Summary/RESET_INITIAL_META_DATA_STATE';

type Types = {
  REQUEST_META_DATA_OK: typeof REQUEST_META_DATA_OK;
  RESET_INITIAL_META_DATA_STATE: typeof RESET_INITIAL_META_DATA_STATE;
};

const types: Types = {
  REQUEST_META_DATA_OK,
  RESET_INITIAL_META_DATA_STATE,
};

type RequestMetaDataOK = (metaData: MetaData) => {
  type: typeof REQUEST_META_DATA_OK;
} & MetaData;

type ResetInitialMetaDataState = (metaData: MetaData) => {
  type: typeof RESET_INITIAL_META_DATA_STATE;
  metaData: MetaData;
};

export type Action = ReturnType<RequestMetaDataOK> | ReturnType<ResetInitialMetaDataState>;

export type ActionCreators = {
  RequestMetaDataOK: RequestMetaDataOK;
  ResetInitialMetaDataState: ResetInitialMetaDataState;
};

/* State Types */

type OfferComponentMetaData = {
  error: Error | null;
  errorMessages: ErrorMessage[];
  dirty: boolean;
  submitting: boolean;
};
export type MetaData = {
  expireAt: Date | null;
  fulfillmentCount?: number;
  offerId: string;
  publishAt: Date | null;
};
export type State = OfferComponentMetaData & MetaData;

export default types;
